import { Modules } from '../../../util/modules'
import { RouteConfig } from 'vue-router'
import { invoicesRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../../auth'
// Invoices App
const InvoiceEditor = () => import('@/pmd/pages/payments/payment-products/InvoiceEditor.vue')
const InvoiceTemplateEditor = () => import('@/pmd/pages/payments/payment-products/InvoiceTemplateEditor.vue')
const RecurringInvoiceEditor = () => import('@/pmd/pages/payments/payment-products/RecurringInvoiceEditor.vue')
const ListInvoices = () => import('@/pmd/pages/payments/payment-products/ListInvoices.vue')
const ListRecurringInvoices = () => import('@/pmd/pages/payments/payment-products/ListRecurringInvoices.vue')
const ListTemplates = () => import('@/pmd/pages/payments/payment-products/ListTemplates.vue')
const InvoiceSettingsApp = () => import('@/pmd/pages/payments/payment-products/InvoiceSettingsApp.vue')
const ImportInvoices = () => import('@/pmd/pages/payments/payment-products/ImportInvoices.vue')
const InvoiceCustomization = () => import('@/pmd/pages/payments/payment-products/InvoiceCustomization.vue')
export const invoicesRoutes: RouteConfig[] = [
  {
    path: 'payments/invoices',
    name: invoicesRouteNames.listInvoices,
    component: ListInvoices,
    beforeEnter: requireAuthAndLocation,
    meta: {
      translations: [Modules.Payments],
    },
  },
  {
    path: 'payments/recurring-templates',
    name: invoicesRouteNames.listRecurringInvoices,
    component: ListRecurringInvoices,
    beforeEnter: requireAuthAndLocation,
    meta: {
      translations: [Modules.Payments],
    },
  },
  {
    path: 'payments/invoices/import',
    name: invoicesRouteNames.importInvoices,
    component: ImportInvoices,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
  },
  {
    path: 'payments/invoices/:invoiceId',
    name: invoicesRouteNames.invoiceEditor,
    component: InvoiceEditor,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
  },
  {
    path: 'payments/invoice-templates/:templateId',
    name: invoicesRouteNames.invoiceTemplateEditor,
    component: InvoiceTemplateEditor,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
  },
  {
    path: 'payments/invoice-templates',
    name: invoicesRouteNames.listInvoiceTemplates,
    component: ListTemplates,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: false,
      hideTopBar: false,
      translations: [Modules.Payments],
    },
  },
  {
    path: 'payments/recurring-templates/v2/:scheduleId',
    name: invoicesRouteNames.recurringInvoiceEditor,
    component: RecurringInvoiceEditor,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
  },
  {
    path: 'payments/invoice/settings',
    name: invoicesRouteNames.invoiceSettings,
    component: InvoiceSettingsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: false,
      hideTopBar: false,
      translations: [Modules.Payments],
    },
    children: [],
  },
  {
    path: 'payments/invoice/settings/customize',
    name: invoicesRouteNames.invoiceLayoutCustomization,
    component: InvoiceCustomization,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
    children: [],
  },
]
